(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react/jsx-runtime"), require("react"), require("@emotion/react"), require("@emotion/css"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("midnight", ["react/jsx-runtime", "react", "@emotion/react", "@emotion/css", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["midnight"] = factory(require("react/jsx-runtime"), require("react"), require("@emotion/react"), require("@emotion/css"), require("react-dom"));
	else
		root["midnight"] = factory(root["react/jsx-runtime"], root["react"], root["@emotion/react"], root["@emotion/css"], root["react-dom"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE__emotion_react__, __WEBPACK_EXTERNAL_MODULE__emotion_css__, __WEBPACK_EXTERNAL_MODULE_react_dom__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/Box/Box.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Box": () => (/* binding */ Box)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_element__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("./src/helpers/element/element.ts");
/* harmony import */ var _helpers_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/color/index.ts");
/* harmony import */ var _helpers_animation_useAnimatedProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/animation/useAnimatedProps.ts");
/* harmony import */ var _helpers_properties_accessibility__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("./src/helpers/properties/accessibility.ts");
/* harmony import */ var _helpers_properties_border__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./src/helpers/properties/border.ts");
/* harmony import */ var _helpers_properties_transforms__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("./src/helpers/properties/transforms.ts");
/* harmony import */ var _helpers_properties_visiblyHidden__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./src/helpers/properties/visiblyHidden/visiblyHidden.ts");
/* harmony import */ var _helpers_properties_testing__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("./src/helpers/properties/testing.ts");
/* harmony import */ var _helpers_properties_shadow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("./src/helpers/properties/shadow/mapPropsToShadow.ts");
/* harmony import */ var _helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/helpers/properties/stacking.ts");
/* harmony import */ var _helpers_properties_dimension__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/helpers/properties/dimension.ts");
/* harmony import */ var _helpers_properties_position__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/helpers/properties/position.ts");
/* harmony import */ var _helpers_properties_flexChild__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/helpers/properties/flexChild.ts");
/* harmony import */ var _helpers_properties_flexContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/helpers/properties/flexContainer.ts");
/* harmony import */ var _helpers_properties_padding__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/helpers/properties/padding.ts");
/* harmony import */ var _helpers_properties_margin__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/helpers/properties/margin.ts");
/* harmony import */ var _helpers_properties_web__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/properties/web.ts");



















const tableElements = ["table", "tbody", "td", "th", "thead", "tr", "tfoot"];
const Box = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function Box2(props, ref) {
  const {
    children,
    display = "flex",
    renderAs,
    backgroundColor,
    cursor,
    id,
    opacity
  } = props;
  let displayValue = display;
  if (renderAs) {
    const type = typeof renderAs === "string" ? renderAs : renderAs.type;
    if (typeof type === "string" && tableElements.includes(type)) {
      displayValue = void 0;
    }
  }
  const animatedStyle = (0,_helpers_animation_useAnimatedProps__WEBPACK_IMPORTED_MODULE_2__.useAnimatedProps)(props, props.animated);
  const getStyles = () => {
    const mediaQueries = {};
    const styles = {
      backgroundColor: backgroundColor ? (0,_helpers_color__WEBPACK_IMPORTED_MODULE_3__.resolveColor)(backgroundColor) : "transparent",
      cursor,
      opacity,
      textDecoration: "none"
    };
    (0,_helpers_properties_web__WEBPACK_IMPORTED_MODULE_4__.mapPropsToWeb)({ display: displayValue }, styles, mediaQueries);
    (0,_helpers_properties_dimension__WEBPACK_IMPORTED_MODULE_5__.mapPropsToDimension)(props, styles, mediaQueries);
    (0,_helpers_properties_flexChild__WEBPACK_IMPORTED_MODULE_6__.mapPropsToFlexChild)(props, styles, mediaQueries);
    (0,_helpers_properties_flexContainer__WEBPACK_IMPORTED_MODULE_7__.mapPropsToFlexContainer)(props, styles, mediaQueries);
    (0,_helpers_properties_margin__WEBPACK_IMPORTED_MODULE_8__.mapPropsToMargin)(props, styles, mediaQueries);
    (0,_helpers_properties_padding__WEBPACK_IMPORTED_MODULE_9__.mapPropsToPadding)(props, styles, mediaQueries);
    (0,_helpers_properties_position__WEBPACK_IMPORTED_MODULE_10__.mapPropsToPosition)(props, styles, mediaQueries);
    (0,_helpers_properties_border__WEBPACK_IMPORTED_MODULE_11__.mapPropsToBorder)(props, styles, mediaQueries);
    (0,_helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_12__.mapPropsToStacking)(props, styles);
    (0,_helpers_properties_visiblyHidden__WEBPACK_IMPORTED_MODULE_13__.mapPropsToVisiblyHidden)(props, styles);
    (0,_helpers_properties_shadow__WEBPACK_IMPORTED_MODULE_14__.mapPropsToShadow)(props, styles);
    (0,_helpers_properties_transforms__WEBPACK_IMPORTED_MODULE_15__.mapPropsToTransforms)(props, styles);
    animatedStyle && Object.assign(styles, animatedStyle);
    Object.assign(styles, mediaQueries);
    return styles;
  };
  const boxProps = {
    children,
    css: getStyles(),
    id,
    ref
  };
  (0,_helpers_properties_testing__WEBPACK_IMPORTED_MODULE_16__.mapPropsToTestingProps)(props, boxProps);
  (0,_helpers_properties_accessibility__WEBPACK_IMPORTED_MODULE_17__.mapPropsToAccessibility)(props, boxProps);
  return (0,_helpers_element__WEBPACK_IMPORTED_MODULE_18__.element)(/* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}), boxProps, renderAs);
});


/***/ }),

/***/ "./src/Column/Column.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Column": () => (/* binding */ Column)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_useBreakpointValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/useBreakpointValue/useBreakpointValue.ts");
/* harmony import */ var _helpers_properties_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Layout/Layout.tsx");
/* harmony import */ var _Layout_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/Layout/helpers.ts");





const Column = ({
  spacing,
  reverse = { xsmall: false },
  ...restProps
}) => {
  const responsiveReverse = (0,_helpers_properties_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(reverse) ? reverse : { xsmall: reverse };
  const reverseValue = (0,_helpers_useBreakpointValue__WEBPACK_IMPORTED_MODULE_2__.useBreakpointValue)(responsiveReverse);
  const responsiveSpacingProp = (0,_helpers_properties_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(spacing) ? spacing : { xsmall: spacing };
  const spacingValue = (0,_helpers_useBreakpointValue__WEBPACK_IMPORTED_MODULE_2__.useBreakpointValue)(responsiveSpacingProp);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Layout__WEBPACK_IMPORTED_MODULE_3__.Layout,
    {
      ...restProps,
      direction: reverseValue ? "column-reverse" : "column",
      spacing: typeof spacing === "undefined" ? spacing : (0,_Layout_helpers__WEBPACK_IMPORTED_MODULE_4__.getExtendedSpacing)(spacingValue)
    }
  );
};


/***/ }),

/***/ "./src/Image/Image.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Image": () => (/* binding */ Image)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Box/Box.tsx");
/* harmony import */ var _helpers_useBreakpointAttributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useBreakpointAttributes/useBreakpointAttributes.ts");



const Image = ({
  accessibilityLabel,
  src,
  onLoad,
  onError,
  imageFit = "stretch",
  ...restProps
}) => {
  const { width, height } = (0,_helpers_useBreakpointAttributes__WEBPACK_IMPORTED_MODULE_1__.useBreakpointAttributes)({
    width: restProps.width,
    height: restProps.height
  });
  const defaultMaxWidth = isAutoOrUndefined(width) && isAutoOrUndefined(height) ? "100%" : void 0;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Box__WEBPACK_IMPORTED_MODULE_2__.Box,
    {
      flexShrink: 0,
      maxWidth: defaultMaxWidth,
      ...restProps,
      renderAs: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        "img",
        {
          alt: accessibilityLabel,
          src,
          style: { objectFit: imageFitToWeb[imageFit] },
          onLoad,
          onError,
          width,
          height,
          loading: typeof width === "number" && typeof height === "number" ? "lazy" : void 0
        }
      )
    }
  );
};
const imageFitToWeb = {
  center: "scale-down",
  contain: "contain",
  cover: "cover",
  stretch: "fill"
};
const isAutoOrUndefined = (value) => {
  return value === void 0 || value === "auto";
};


/***/ }),

/***/ "./src/Layout/Layout.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Layout": () => (/* binding */ Layout)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Box/Box.tsx");



const Layout = ({
  direction,
  spacing,
  children,
  flexWrap,
  alignItems = "flex-start",
  justifyContent,
  overflow,
  ...restProps
}) => {
  const isRow = direction === "row" || direction === "row-reverse";
  const isReverse = direction === "column-reverse" || direction === "row-reverse";
  const isWrapping = flexWrap === "wrap";
  let childrenWithSpacing;
  const isReactNodeArray = Array.isArray(children);
  if (isReactNodeArray) {
    const flattenedChildren = flattenNode(children);
    childrenWithSpacing = flattenedChildren.map((child, index) => {
      const props = getSpacing({
        isLast: index === flattenedChildren.length - 1,
        isRow,
        isWrapping,
        spacing,
        isReverse
      });
      if ((0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child)) {
        return (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, {
          key: getChildKey(child, index),
          ...props
        });
      }
      if (typeof child === "function") {
        return child(props, index);
      }
      return child;
    });
  } else {
    childrenWithSpacing = children ?? [];
  }
  const commonBoxProps = {
    alignItems,
    direction,
    flexWrap,
    justifyContent
  };
  if (isWrapping) {
    const conditionalNegativeSpacing = spacing === void 0 ? void 0 : -spacing;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__.Box, { width: "100%", overflow, ...restProps, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _Box__WEBPACK_IMPORTED_MODULE_2__.Box,
      {
        ...commonBoxProps,
        width: overflow === "hidden" ? "100%" : void 0,
        marginBottom: conditionalNegativeSpacing,
        ...isReverse ? { marginLeft: conditionalNegativeSpacing } : { marginRight: conditionalNegativeSpacing },
        children: childrenWithSpacing
      }
    ) });
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__.Box, { overflow, ...commonBoxProps, ...restProps, children: childrenWithSpacing });
};
const flattenNode = (children) => children.reduce((acc, currentElement) => {
  if ((0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(currentElement) && currentElement.type === react__WEBPACK_IMPORTED_MODULE_1__.Fragment) {
    if (Array.isArray(currentElement.props.children)) {
      acc.push(...currentElement.props.children);
      return acc;
    }
    acc.push(currentElement.props.children);
    return acc;
  }
  if (Array.isArray(currentElement)) {
    acc.push(...currentElement);
    return acc;
  }
  if (currentElement) {
    acc.push(currentElement);
  }
  return acc;
}, []);
const getChildKey = (element, index) => element.key || `${element.props.id || ""}.${index.toString(36)}`;
const getSpacing = ({
  isLast,
  isRow,
  isWrapping,
  spacing,
  isReverse
}) => {
  if (spacing === void 0) {
    return {};
  }
  if (isRow) {
    if (isWrapping) {
      if (isReverse) {
        return { marginBottom: spacing, marginLeft: spacing };
      }
      return { marginBottom: spacing, marginRight: spacing };
    }
    if (isReverse) {
      return { marginLeft: isLast ? void 0 : spacing };
    }
    return { marginRight: isLast ? void 0 : spacing };
  }
  if (isReverse) {
    return { marginTop: isLast ? void 0 : spacing };
  }
  return { marginBottom: isLast ? void 0 : spacing };
};


/***/ }),

/***/ "./src/Layout/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getExtendedSpacing": () => (/* binding */ getExtendedSpacing)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);

const deprecatedSpacings = {
  actions: 12,
  cards: 16
};
const getExtendedSpacing = (token) => {
  if (!token)
    return void 0;
  if ((0,_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.isSpacingToken)(token)) {
    return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.spacings[token];
  }
  return deprecatedSpacings[token];
};


/***/ }),

/***/ "./src/Portal/Portal.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Portal": () => (/* binding */ Portal)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/Box/Box.tsx");
/* harmony import */ var _helpers_platform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/platform/Platform.ts");
/* harmony import */ var _helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/properties/stacking.ts");






const Portal = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function Portal2({
  children,
  position: positionInput,
  stackLayer: stackLayerInput,
  stackPriority: stackPriorityInput,
  ...props
}, ref) {
  const { stackLayer, stackPriority } = (0,_helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_3__.useStackingContext)({
    stackLayer: stackLayerInput,
    stackPriority: stackPriorityInput
  });
  let position;
  if (stackLayer || stackPriority) {
    position = "relative";
  }
  if (positionInput) {
    position = positionInput;
  }
  if (_helpers_platform__WEBPACK_IMPORTED_MODULE_4__.Platform.isServer) {
    return null;
  }
  return (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _Box__WEBPACK_IMPORTED_MODULE_5__.Box,
      {
        ref,
        position,
        stackLayer,
        stackPriority,
        ...props,
        children
      }
    ),
    document.body
  );
});


/***/ }),

/***/ "./src/Positioner/Positioner.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Positioner": () => (/* binding */ Positioner)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_useToken__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/useToken/index.ts");
/* harmony import */ var _helpers_animation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/helpers/animation/helpers.ts");
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Box/Box.tsx");
/* harmony import */ var _Transition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/Transition/Transition.tsx");
/* harmony import */ var _PositionerContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/Positioner/PositionerContent.tsx");







const Positioner = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  function Positioner2({
    autoAlignment = true,
    autoPlacement = true,
    children,
    alignment = "center",
    content,
    contentProps,
    contentRole,
    isOpen,
    placement = "bottom",
    placementOffset = "spacing-60",
    transitionDuration = 150,
    onPointerDown,
    ...restProps
  }, ref) {
    const [isMounted, setIsMounted] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { spacings } = (0,_helpers_useToken__WEBPACK_IMPORTED_MODULE_2__.useToken)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, () => ({
      container: containerRef.current,
      content: contentRef.current
    }));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
      setIsMounted(true);
    }, []);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_3__.Box, { ...restProps, ref: containerRef, children: [
      children,
      content ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        _Transition__WEBPACK_IMPORTED_MODULE_4__.Transition,
        {
          isMounted: isMounted && isOpen,
          transitionDuration,
          children: (transitionState) => {
            const enterState = transitionState === "entered" || transitionState === "entering";
            const transform = [
              placement === "bottom" || placement === "top" ? {
                translateY: enterState ? 0 : 10 * (placement === "top" ? 1 : -1)
              } : {
                translateX: enterState ? 0 : 10 * (placement === "left" ? 1 : -1)
              }
            ];
            return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
              _PositionerContent__WEBPACK_IMPORTED_MODULE_5__.PositionerContent,
              {
                ref: contentRef,
                targetRef: containerRef,
                onPointerDown,
                alignment,
                autoAlignment,
                autoPlacement,
                placement,
                placementOffset: spacings[placementOffset],
                animated: (0,_helpers_animation__WEBPACK_IMPORTED_MODULE_6__.transition)(
                  ["opacity", "transform.translateX", "transform.translateY"],
                  transitionDuration,
                  "ease-out"
                ),
                ...contentProps,
                opacity: enterState ? 1 : 0,
                role: contentRole,
                transform,
                children: content
              }
            );
          }
        }
      ) : null
    ] });
  }
);


/***/ }),

/***/ "./src/Positioner/PositionerContent.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PositionerContent": () => (/* binding */ PositionerContent)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/Box/Box.tsx");
/* harmony import */ var _helpers_useElementResizeListener__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/useElementResizeListener/useElementResizeListener.ts");
/* harmony import */ var _Portal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/Portal/Portal.tsx");
/* harmony import */ var _helpers_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/useIsomorphicLayoutEffect/index.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Positioner/helpers.ts");







const PositionerContent = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function PositionerContent2({
  autoAlignment,
  autoPlacement,
  alignment,
  placement,
  children,
  role,
  placementOffset,
  targetRef,
  onPointerDown,
  ...props
}, ref) {
  const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, () => contentRef.current);
  const calculateContentPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(
    () => (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.positionContent)({
      autoAlignment,
      autoPlacement,
      alignment,
      contentElement: contentRef.current,
      placement,
      placementOffset,
      targetElement: targetRef.current
    }),
    [
      alignment,
      autoAlignment,
      autoPlacement,
      placement,
      placementOffset,
      targetRef
    ]
  );
  (0,_helpers_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__.useIsomorphicLayoutEffect)(() => {
    calculateContentPosition();
    const refreshPosition = () => {
      window.requestAnimationFrame(calculateContentPosition);
    };
    window.addEventListener("resize", refreshPosition);
    return () => {
      window.removeEventListener("resize", refreshPosition);
    };
  }, [calculateContentPosition]);
  (0,_helpers_useElementResizeListener__WEBPACK_IMPORTED_MODULE_4__.useElementResizeListener)(targetRef, () => {
    calculateContentPosition();
  });
  (0,_helpers_useElementResizeListener__WEBPACK_IMPORTED_MODULE_4__.useElementResizeListener)(contentRef, () => {
    calculateContentPosition();
  });
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Portal__WEBPACK_IMPORTED_MODULE_5__.Portal, { ref: contentRef, position: "absolute", stackLayer: "popover", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Box__WEBPACK_IMPORTED_MODULE_6__.Box,
    {
      renderAs: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { role: role ? role : void 0, onPointerDown }),
      ...props,
      children
    }
  ) });
});


/***/ }),

/***/ "./src/Positioner/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "positionContent": () => (/* binding */ positionContent)
/* harmony export */ });
const clamp = ({
  value,
  min,
  max
}) => {
  if (value <= min) {
    return min;
  }
  if (max <= value) {
    return max;
  }
  return value;
};
const VIEWPORT_SAFE_AREA_OFFSET = 8;
const getSpaceTakenByContent = ({
  content,
  placementOffset
}) => {
  return {
    width: content.width + placementOffset + VIEWPORT_SAFE_AREA_OFFSET,
    height: content.height + placementOffset + VIEWPORT_SAFE_AREA_OFFSET
  };
};
const reversedPlacement = {
  bottom: "top",
  left: "right",
  right: "left",
  top: "bottom"
};
const getOptimalPlacement = ({
  autoPlacement,
  desiredPlacement,
  targetClientRect,
  placementOffset,
  content
}) => {
  if (!autoPlacement) {
    return {
      placement: desiredPlacement,
      forceInViewport: false
    };
  }
  const spaceTakenByContent = getSpaceTakenByContent({
    content,
    placementOffset
  });
  const spaceAvailableAroundTarget = {
    top: targetClientRect.top,
    bottom: window.innerHeight - targetClientRect.bottom,
    left: targetClientRect.left,
    right: window.innerWidth - targetClientRect.right
  };
  const remainingSpaceWithContent = {
    top: spaceAvailableAroundTarget.top - spaceTakenByContent.height,
    bottom: spaceAvailableAroundTarget.bottom - spaceTakenByContent.height,
    left: spaceAvailableAroundTarget.left - spaceTakenByContent.width,
    right: spaceAvailableAroundTarget.right - spaceTakenByContent.width
  };
  const oppositePlacement = reversedPlacement[desiredPlacement];
  const canFitInDesiredPlacement = 0 <= remainingSpaceWithContent[desiredPlacement];
  const canFitInOppositePlacement = 0 <= remainingSpaceWithContent[oppositePlacement];
  let finalPlacement = desiredPlacement;
  if (!canFitInDesiredPlacement) {
    finalPlacement = remainingSpaceWithContent[desiredPlacement] >= remainingSpaceWithContent[oppositePlacement] ? desiredPlacement : oppositePlacement;
  }
  return {
    placement: finalPlacement,
    // @note: we force the content into the view if there isn't any available place on both the desired and opposite placement
    forceInViewport: !canFitInDesiredPlacement && !canFitInOppositePlacement
  };
};
const calculatePosition = ({
  placement,
  placementOffset,
  alignment,
  target,
  content,
  forceInViewport
}) => {
  let left;
  let top;
  if (forceInViewport) {
    if (placement === "top") {
      top = window.scrollY + VIEWPORT_SAFE_AREA_OFFSET;
    } else if (placement === "bottom") {
      top = window.scrollY + window.innerHeight - content.height - VIEWPORT_SAFE_AREA_OFFSET;
    } else if (placement === "left") {
      left = window.scrollX + VIEWPORT_SAFE_AREA_OFFSET;
    } else if (placement === "right") {
      left = window.scrollX + window.innerWidth - content.width - VIEWPORT_SAFE_AREA_OFFSET;
    }
  } else {
    if (placement === "top") {
      top = target.top - placementOffset - content.height;
    } else if (placement === "bottom") {
      top = target.top + target.height + placementOffset;
    } else if (placement === "left") {
      left = target.left - placementOffset - content.width;
    } else if (placement === "right") {
      left = target.left + target.width + placementOffset;
    }
  }
  if (placement === "top" || placement === "bottom") {
    if (alignment === "start" || alignment === "stretch") {
      left = target.left;
    } else if (alignment === "center") {
      left = target.left + Math.round(target.width / 2 - content.width / 2);
    } else if (alignment === "end") {
      left = target.left + target.width - content.width;
    }
  } else {
    if (alignment === "start" || alignment === "stretch") {
      top = target.top;
    } else if (alignment === "center") {
      top = target.top + Math.round(target.height / 2 - content.height / 2);
    } else if (alignment === "end") {
      top = target.top + target.height - content.height;
    }
  }
  const spaceTakenByContent = getSpaceTakenByContent({
    content,
    placementOffset
  });
  return {
    top: top !== void 0 ? clamp({
      value: top,
      min: VIEWPORT_SAFE_AREA_OFFSET,
      max: document.body.scrollHeight - spaceTakenByContent.height
    }) : void 0,
    left: left !== void 0 ? clamp({
      value: left,
      min: VIEWPORT_SAFE_AREA_OFFSET,
      max: document.body.scrollWidth - spaceTakenByContent.width
    }) : void 0
  };
};
const getContentDimension = ({
  autoAlignment,
  alignment,
  placement,
  target,
  content
}) => {
  const dimensionProperty = placement === "top" || placement === "bottom" ? "width" : "height";
  const targetIsBiggerThanContent = target[dimensionProperty] > content[dimensionProperty];
  const contentMustNotBeStretch = alignment === "start" && targetIsBiggerThanContent && dimensionProperty === "width";
  const contentMustBeStretched = !contentMustNotBeStretch && (alignment === "stretch" || autoAlignment && targetIsBiggerThanContent);
  return {
    [dimensionProperty]: contentMustBeStretched ? target[dimensionProperty] : void 0
  };
};
const positionContent = ({
  alignment,
  autoAlignment,
  autoPlacement,
  contentElement,
  placement: placementParam,
  placementOffset,
  targetElement
}) => {
  const targetClientRect = targetElement.getBoundingClientRect();
  const content = {
    height: contentElement.offsetHeight,
    width: contentElement.offsetWidth
  };
  const target = {
    height: targetClientRect.height,
    width: targetClientRect.width,
    left: targetClientRect.left + window.scrollX,
    top: targetClientRect.top + window.scrollY
  };
  const { placement, forceInViewport } = getOptimalPlacement({
    autoPlacement,
    desiredPlacement: placementParam,
    targetClientRect,
    placementOffset,
    content
  });
  const { height, width } = getContentDimension({
    autoAlignment,
    alignment,
    placement,
    target,
    content
  });
  if (height !== void 0) {
    content.height = height;
  }
  if (width !== void 0) {
    content.width = width;
  }
  const { top, left } = calculatePosition({
    placementOffset,
    placement,
    alignment,
    target,
    content,
    forceInViewport
  });
  contentElement.style.left = left !== void 0 ? `${left}px` : "";
  contentElement.style.top = top !== void 0 ? `${top}px` : "";
  contentElement.style.width = width !== void 0 ? `${width}px` : "";
  contentElement.style.height = height !== void 0 ? `${height}px` : "";
};


/***/ }),

/***/ "./src/Text/Text.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Text": () => (/* binding */ Text)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/Typography/Typography.tsx");
/* harmony import */ var _helpers_useToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useToken/index.ts");
/* harmony import */ var _helpers_useWarning__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/useWarning/index.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Text/helpers.ts");





const Text = ({
  color: colorProp,
  hasLineThrough,
  isCapitalized,
  size = "text-100",
  variation,
  ...restProps
}) => {
  const { typographies } = (0,_helpers_useToken__WEBPACK_IMPORTED_MODULE_1__.useToken)();
  const sizeProps = typographies[size];
  const variationProps = mapVariationPropsToTypographyProps(variation);
  const fontVariation = variationProps.fontVariation || sizeProps.fontVariation;
  const utilityProps = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.mapUtilityToTypographyProps)({
    isCapitalized
  });
  const color = colorProp ? colorProp : fontVariation === "bold" ? "navy200" : "navy80";
  (0,_helpers_useWarning__WEBPACK_IMPORTED_MODULE_3__.useWarning)(
    [
      "Text",
      `${size} is deprecated. Please use the corresponding \`variation\` prop`
    ],
    Boolean(size && ["text-100-medium", "text-60-caps"].includes(size))
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Typography__WEBPACK_IMPORTED_MODULE_4__.Typography,
    {
      ...restProps,
      color,
      fontSize: sizeProps.fontSize,
      fontVariation,
      fontWeight: variationProps.fontWeight || sizeProps.fontWeight,
      textDecoration: hasLineThrough ? "line-through" : void 0,
      textTransform: variationProps.textTransform || utilityProps.textTransform || sizeProps.textTransform
    }
  );
};
const mapVariationPropsToTypographyProps = (variation) => {
  switch (variation) {
    case "bold":
      return {
        fontVariation: "bold"
      };
    case "normal":
      return {
        fontVariation: "normal"
      };
    case "caps":
      return {
        textTransform: "uppercase",
        fontWeight: 600
      };
    default:
      return {};
  }
};


/***/ }),

/***/ "./src/Text/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapUtilityToTypographyProps": () => (/* binding */ mapUtilityToTypographyProps)
/* harmony export */ });
const mapUtilityToTypographyProps = ({
  isCapitalized
}) => {
  return {
    textTransform: isCapitalized ? "capitalize" : void 0
  };
};


/***/ }),

/***/ "./src/Tooltip/Tooltip.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tooltip": () => (/* binding */ Tooltip)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Positioner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/Positioner/Positioner.tsx");
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/Text/Text.tsx");
/* harmony import */ var _Column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Column/Column.tsx");
/* harmony import */ var _components_TooltipImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Tooltip/components/TooltipImage.tsx");







const MAX_WIDTH = 300;
const IMAGE_PADDING = 12;
const IMAGE_ASPECT_RATIO = 16 / 9;
const IMAGE_WIDTH = MAX_WIDTH - IMAGE_PADDING * 2;
const IMAGE_HEIGHT = Math.round(IMAGE_WIDTH / IMAGE_ASPECT_RATIO);
const CONTENT_PADDING = {
  long: {
    padding: IMAGE_PADDING
  },
  simple: {
    paddingX: 8,
    paddingY: 4
  }
};
const Tooltip = ({
  children,
  tooltipImage,
  isDisabled,
  tooltipContent,
  tooltipPlacement = "top",
  ...restProps
}) => {
  const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const [isTooltipOpen, setTooltipOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const isText = typeof tooltipContent === "string";
  const isLongText = isText && tooltipContent.length >= 60;
  const tooltipPaddingType = tooltipImage || (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(tooltipContent) || isLongText ? "long" : "simple";
  const isOpen = !isDisabled && isTooltipOpen && !!tooltipContent;
  const positionerContent = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Column__WEBPACK_IMPORTED_MODULE_2__.Column, { spacing: "spacing-80", children: [
    tooltipImage && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _components_TooltipImage__WEBPACK_IMPORTED_MODULE_3__.TooltipImage,
      {
        src: tooltipImage,
        width: IMAGE_WIDTH,
        height: IMAGE_HEIGHT
      }
    ),
    isText ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_4__.Text, { color: "white", size: "text-80", children: tooltipContent }) : tooltipContent
  ] });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const containerElement = containerRef.current?.container;
    if (!containerElement) {
      return;
    }
    const open = () => {
      setTooltipOpen(true);
    };
    const close = () => {
      setTooltipOpen(false);
    };
    containerElement.addEventListener("mouseenter", open);
    containerElement.addEventListener("mouseleave", close);
    return () => {
      containerElement.removeEventListener("mouseenter", open);
      containerElement.removeEventListener("mouseleave", close);
    };
  }, []);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Positioner__WEBPACK_IMPORTED_MODULE_5__.Positioner,
    {
      ref: containerRef,
      autoAlignment: false,
      content: positionerContent,
      contentProps: {
        backgroundColor: "navy200",
        borderRadius: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_6__.radii.medium,
        maxWidth: MAX_WIDTH,
        width: tooltipImage ? MAX_WIDTH : void 0,
        ...CONTENT_PADDING[tooltipPaddingType],
        shadow: "shadow-150"
      },
      contentRole: "tooltip",
      isOpen,
      placement: tooltipPlacement,
      transitionDuration: 200,
      ...restProps,
      children
    }
  );
};


/***/ }),

/***/ "./src/Tooltip/components/TooltipImage.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TooltipImage": () => (/* binding */ TooltipImage)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Image/Image.tsx");




const TooltipImage = ({
  src,
  width,
  height,
  ...props
}) => {
  const [hasError, setHasError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  if (hasError) {
    return null;
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Image__WEBPACK_IMPORTED_MODULE_2__.Image,
    {
      src,
      onError: () => {
        setHasError(true);
      },
      borderRadius: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_3__.radii.medium,
      imageFit: "cover",
      width,
      height,
      ...props
    }
  );
};


/***/ }),

/***/ "./src/Transition/Transition.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Transition": () => (/* binding */ Transition)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const Transition = ({
  children,
  isMounted,
  transitionDuration
}) => {
  const [transitionState, setTransitionState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const timeoutIdRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const wasOpenRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    if (isMounted) {
      wasOpenRef.current = true;
      setTransitionState("entering");
      timeoutIdRef.current = setTimeout(() => {
        setTransitionState("entered");
      }, transitionDuration);
    } else if (wasOpenRef.current) {
      setTransitionState("exiting");
      timeoutIdRef.current = setTimeout(() => {
        setTransitionState(void 0);
      }, transitionDuration);
    }
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, [isMounted, transitionDuration]);
  return transitionState || isMounted ? children(transitionState || "exited") : null;
};


/***/ }),

/***/ "./src/Typography/Typography.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Typography": () => (/* binding */ Typography)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/color/index.ts");
/* harmony import */ var _helpers_element__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./src/helpers/element/element.ts");
/* harmony import */ var _helpers_animation_useAnimatedProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/animation/useAnimatedProps.ts");
/* harmony import */ var _helpers_properties_accessibility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./src/helpers/properties/accessibility.ts");
/* harmony import */ var _helpers_properties_margin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/properties/margin.ts");
/* harmony import */ var _helpers_properties_padding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/helpers/properties/padding.ts");
/* harmony import */ var _helpers_properties_position__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/helpers/properties/position.ts");
/* harmony import */ var _helpers_properties_border__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/helpers/properties/border.ts");
/* harmony import */ var _helpers_properties_visiblyHidden__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/helpers/properties/visiblyHidden/visiblyHidden.ts");
/* harmony import */ var _helpers_properties_testing__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/helpers/properties/testing.ts");
/* harmony import */ var _helpers_properties_transforms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/helpers/properties/transforms.ts");
/* harmony import */ var _helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/helpers/properties/stacking.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Typography/helpers.ts");














const Typography = (props) => {
  const {
    children,
    color,
    renderAs,
    backgroundColor,
    fontSize,
    fontVariation,
    fontWeight,
    id,
    letterSpacing,
    lineHeight,
    opacity,
    textAlign,
    textDecoration,
    textTransform
  } = props;
  const animatedStyle = (0,_helpers_animation_useAnimatedProps__WEBPACK_IMPORTED_MODULE_1__.useAnimatedProps)(props, props.animated);
  const lineHeightValue = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.getLineHeight)({ lineHeight, fontSize });
  const getStyles = () => {
    const mediaQueries = {};
    const styles = {
      backgroundColor: backgroundColor && (0,_helpers_color__WEBPACK_IMPORTED_MODULE_3__.resolveColor)(backgroundColor),
      color: color && (0,_helpers_color__WEBPACK_IMPORTED_MODULE_3__.resolveColor)(color),
      fontSize,
      fontStyle: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.getFontStyle)({ fontVariation }),
      fontWeight: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.getFontWeight)({ fontVariation, fontWeight }),
      letterSpacing,
      lineHeight: lineHeightValue ? `${lineHeightValue}px` : void 0,
      opacity,
      textAlign,
      textDecoration,
      textTransform
    };
    (0,_helpers_properties_margin__WEBPACK_IMPORTED_MODULE_4__.mapPropsToMargin)(props, styles, mediaQueries);
    (0,_helpers_properties_padding__WEBPACK_IMPORTED_MODULE_5__.mapPropsToPadding)(props, styles, mediaQueries);
    (0,_helpers_properties_position__WEBPACK_IMPORTED_MODULE_6__.mapPropsToPosition)(props, styles, mediaQueries);
    (0,_helpers_properties_border__WEBPACK_IMPORTED_MODULE_7__.mapPropsToBorder)(props, styles, mediaQueries);
    mapPropsToEllipsis(props, styles);
    mapPropsToOverflow(props, styles);
    (0,_helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_8__.mapPropsToStacking)(props, styles);
    (0,_helpers_properties_visiblyHidden__WEBPACK_IMPORTED_MODULE_9__.mapPropsToVisiblyHidden)(props, styles);
    (0,_helpers_properties_transforms__WEBPACK_IMPORTED_MODULE_10__.mapPropsToTransforms)(props, styles);
    animatedStyle && Object.assign(styles, animatedStyle);
    Object.assign(styles, mediaQueries);
    return styles;
  };
  const textProps = {
    children,
    css: getStyles(),
    id
  };
  (0,_helpers_properties_accessibility__WEBPACK_IMPORTED_MODULE_11__.mapPropsToAccessibility)(props, textProps);
  (0,_helpers_properties_testing__WEBPACK_IMPORTED_MODULE_12__.mapPropsToTestingProps)(props, textProps);
  return (0,_helpers_element__WEBPACK_IMPORTED_MODULE_13__.element)(
    getRenderAsElement({
      fontVariation,
      textDecoration
    }),
    textProps,
    renderAs
  );
};
const mapPropsToEllipsis = ({ hasEllipsis, whiteSpace }, style) => {
  style.whiteSpace = whiteSpace;
  if (hasEllipsis) {
    style.overflow = "hidden";
    style.textOverflow = "ellipsis";
    style.whiteSpace = "nowrap";
  }
};
const mapPropsToOverflow = ({ withWrapping }, style) => {
  if (withWrapping) {
    style.wordBreak = "break-word";
  }
};
const getRenderAsElement = ({
  fontVariation,
  textDecoration
}) => {
  switch (true) {
    case fontVariation === "bold":
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {});
    case fontVariation === "italic":
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {});
    case textDecoration === "line-through":
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("del", {});
    case textDecoration === "underline":
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {});
    default:
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
  }
};


/***/ }),

/***/ "./src/Typography/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getFontStyle": () => (/* binding */ getFontStyle),
/* harmony export */   "getFontWeight": () => (/* binding */ getFontWeight),
/* harmony export */   "getLineHeight": () => (/* binding */ getLineHeight),
/* harmony export */   "getLineHeightRatio": () => (/* binding */ getLineHeightRatio)
/* harmony export */ });
const getLineHeight = ({
  fontSize,
  lineHeight
}) => {
  if (lineHeight) {
    return lineHeight;
  }
  if (!fontSize) {
    return void 0;
  }
  return Math.round(fontSize * getLineHeightRatio(fontSize));
};
const getLineHeightRatio = (fontSize) => {
  return fontSize >= 20 ? 1.4 : 1.55;
};
const getFontWeight = ({
  fontWeight,
  fontVariation
}) => {
  if (fontWeight) {
    return fontWeight;
  }
  switch (fontVariation) {
    case "bold":
      return 500;
    case "italic":
    case "normal":
      return 400;
    default:
      return void 0;
  }
};
const getFontStyle = ({
  fontVariation
}) => {
  if (fontVariation === "bold") {
    return void 0;
  }
  return fontVariation;
};


/***/ }),

/***/ "./src/helpers/animation/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bezier": () => (/* binding */ bezier),
/* harmony export */   "isSpinningAnimation": () => (/* binding */ isSpinningAnimation),
/* harmony export */   "isTransition": () => (/* binding */ isTransition),
/* harmony export */   "spin": () => (/* binding */ spin),
/* harmony export */   "transition": () => (/* binding */ transition)
/* harmony export */ });
const isTransition = (animatedProp) => animatedProp.type === "transition";
const isSpinningAnimation = (animatedProp) => animatedProp.type === "spin";
const bezier = (x1, y1, x2, y2) => ({
  x1,
  x2,
  y1,
  y2
});
const transition = (propNames, duration, timingFunction, delay) => ({
  delay,
  duration,
  propNames: Array.isArray(propNames) ? propNames : [propNames],
  timingFunction,
  type: "transition"
});
const spin = (revolutionDuration, timingFunction = "linear", iterations) => ({
  iterations,
  revolutionDuration,
  timingFunction,
  type: "spin"
});


/***/ }),

/***/ "./src/helpers/animation/useAnimatedProps.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useAnimatedProps": () => (/* binding */ useAnimatedProps)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@emotion/react");
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_emotion_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _useAccessibilityListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/useAccessibilityListener/useAccessibilityListener.tsx");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/animation/helpers.ts");




const spinKeyframes = _emotion_react__WEBPACK_IMPORTED_MODULE_1__.keyframes`
from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const toCubicBezier = (timingFunction) => `cubic-bezier(${timingFunction.x1}, ${timingFunction.y1}, ${timingFunction.x2}, ${timingFunction.y2})`;
const useAnimatedProps = (props, animated = []) => {
  const { hasReducedMotion } = (0,_useAccessibilityListener__WEBPACK_IMPORTED_MODULE_2__.useAccessibilityListener)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (hasReducedMotion) {
      return void 0;
    }
    const styles = {};
    const animatedList = Array.isArray(animated) ? animated : [animated];
    const transition = animatedList.reduce((acc, animatedProp) => {
      if (!(0,_helpers__WEBPACK_IMPORTED_MODULE_3__.isTransition)(animatedProp)) {
        return acc;
      }
      const { delay = 0, duration, timingFunction = "ease" } = animatedProp;
      const animationTimingFunction = typeof timingFunction === "string" ? timingFunction : toCubicBezier(timingFunction);
      animatedProp.propNames.forEach((name) => {
        let propName;
        if (name.startsWith("transform")) {
          propName = "transform";
        } else {
          propName = name;
        }
        if (!acc.includes(propName)) {
          acc.push(
            `${propName.replace(
              /([a-z])([A-Z])/g,
              "$1-$2"
            )} ${duration}ms ${animationTimingFunction} ${delay}s`
          );
        }
      });
      return acc;
    }, []).join(",");
    if (transition) {
      styles.transition = transition;
    }
    const spinningAnimation = animatedList.find(_helpers__WEBPACK_IMPORTED_MODULE_3__.isSpinningAnimation);
    if (spinningAnimation) {
      const {
        iterations,
        revolutionDuration,
        timingFunction = "linear"
      } = spinningAnimation;
      styles.animation = `${spinKeyframes} ${revolutionDuration}ms ${typeof timingFunction === "string" ? timingFunction : toCubicBezier(timingFunction)} ${iterations ? iterations.toString() : "infinite"}`;
    }
    return styles;
  }, [hasReducedMotion]);
};


/***/ }),

/***/ "./src/helpers/color/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HexColor": () => (/* binding */ HexColor),
/* harmony export */   "hexColor": () => (/* binding */ hexColor),
/* harmony export */   "resolveColor": () => (/* binding */ resolveColor)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);

class HexColor {
  constructor(c) {
    this.color = c;
  }
  toString() {
    return this.color;
  }
}
const hexColor = (color) => new HexColor(color);
const resolveColor = (color) => {
  return color instanceof HexColor ? color.toString() : _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.colors[color];
};


/***/ }),

/***/ "./src/helpers/element/element.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "element": () => (/* binding */ element)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@emotion/react");
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_emotion_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("@emotion/css");
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_emotion_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/platform/Platform.ts");




const PROCESS_STYLE_EXTRACTION = _platform__WEBPACK_IMPORTED_MODULE_3__.Platform.isServer;
const element = (base, props, overridable) => {
  const element2 = overridable || base;
  const { css: cssProp, ...restProps } = props;
  const processClassName = (customClassNames) => {
    const className = (0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__.css)(cssProp);
    const filteredClassNames = customClassNames.filter(Boolean);
    return {
      ...restProps,
      className: [className, ...filteredClassNames].join(" ")
    };
  };
  if (typeof element2 === "string") {
    return createFromTag(
      element2,
      PROCESS_STYLE_EXTRACTION ? props : processClassName([restProps.className])
    );
  }
  return createFromElement(
    element2,
    PROCESS_STYLE_EXTRACTION ? props : processClassName([restProps.className, element2.props.className])
  );
};
const createFromTag = (Element, props) => {
  const create = PROCESS_STYLE_EXTRACTION ? _emotion_react__WEBPACK_IMPORTED_MODULE_1__.jsx : react__WEBPACK_IMPORTED_MODULE_0__.createElement;
  return create(Element, props);
};
const createFromElement = (Element, props) => {
  return PROCESS_STYLE_EXTRACTION ? (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.jsx)(Element.type, {
      key: Element.key,
      ref: Element.ref,
      ...Element.props,
      ...props
    })
  ) : (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(Element, props);
};


/***/ }),

/***/ "./src/helpers/platform/Platform.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Platform": () => (/* binding */ Platform)
/* harmony export */ });
const getBrowserType = () => {
  if (typeof navigator === "undefined") {
    return void 0;
  }
  const userAgent = navigator.userAgent.toLowerCase();
  switch (true) {
    case userAgent.includes("msie"):
      return "ie";
    case userAgent.includes("firefox"):
      return "firefox";
    case userAgent.includes("opr"):
      return "opera";
    case userAgent.includes("chrome"):
      return "chrome";
    case userAgent.includes("safari"):
      return "safari";
    default:
      return void 0;
  }
};
const IS_SERVER = typeof window === "undefined";
const Platform = {
  browserType: getBrowserType(),
  isServer: IS_SERVER
};


/***/ }),

/***/ "./src/helpers/platform/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Platform": () => (/* reexport safe */ _Platform__WEBPACK_IMPORTED_MODULE_0__.Platform),
/* harmony export */   "isDevEnvironment": () => (/* binding */ isDevEnvironment),
/* harmony export */   "isTestingEnvironment": () => (/* binding */ isTestingEnvironment)
/* harmony export */ });
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/platform/Platform.ts");

const isTestingEnvironment = "development" === "test";
const isDevEnvironment = "development" !== "production";


/***/ }),

/***/ "./src/helpers/properties/accessibility.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToAccessibility": () => (/* binding */ mapPropsToAccessibility)
/* harmony export */ });
const mapPropsToAccessibility = ({
  accessibilityChecked,
  accessibilityCurrent,
  accessibilityHidden,
  accessibilityLabel,
  accessibilityDisabled,
  accessibilityOwns,
  accessibilityPopupRole,
  accessibilityPopupExtended = false
}, boxProps) => {
  if (accessibilityLabel !== void 0) {
    boxProps["aria-label"] = accessibilityLabel;
  }
  if (accessibilityHidden !== void 0) {
    boxProps["aria-hidden"] = accessibilityHidden;
  }
  if (accessibilityDisabled !== void 0) {
    boxProps["aria-disabled"] = accessibilityDisabled;
  }
  if (accessibilityChecked !== void 0) {
    boxProps["aria-checked"] = accessibilityChecked;
  }
  if (accessibilityCurrent !== void 0) {
    boxProps["aria-current"] = accessibilityCurrent;
  }
  if (accessibilityPopupRole !== void 0) {
    boxProps["aria-haspopup"] = accessibilityPopupRole;
    boxProps["aria-expanded"] = accessibilityPopupExtended;
    boxProps["aria-owns"] = accessibilityOwns;
  }
};


/***/ }),

/***/ "./src/helpers/properties/border.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToBorder": () => (/* binding */ mapPropsToBorder)
/* harmony export */ });
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/color/index.ts");
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const directions = ["Top", "Right", "Bottom", "Left"];
const mapPropsToBorderLine = ({
  borderColor,
  borderStyle,
  borderWidth,
  ...restProps
}) => {
  return directions.reduce((style, direction) => {
    const colorProp = `border${direction}Color`;
    const widthProp = `border${direction}Width`;
    const color = restProps[colorProp] || borderColor;
    const hasBorder = color && borderWidth !== 0;
    if (hasBorder) {
      style[widthProp] = restProps[widthProp] || borderWidth || 1;
      style[colorProp] = (0,_color__WEBPACK_IMPORTED_MODULE_0__.resolveColor)(color);
      if (!style.borderStyle) {
        style.borderStyle = borderStyle || "solid";
      }
    }
    return style;
  }, {});
};
const mapPropsToBorder = ({
  borderRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  ...restProps
}, styles, mediaQueries = {}) => {
  const blr = borderBottomLeftRadius || borderRadius;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(blr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(blr, styles, mediaQueries, "borderBottomLeftRadius");
  } else {
    styles.borderBottomLeftRadius = blr;
  }
  const brr = borderBottomRightRadius || borderRadius;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(brr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(brr, styles, mediaQueries, "borderBottomRightRadius");
  } else {
    styles.borderBottomRightRadius = brr;
  }
  const tlr = borderTopLeftRadius || borderRadius;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(tlr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(tlr, styles, mediaQueries, "borderTopLeftRadius");
  } else {
    styles.borderTopLeftRadius = tlr;
  }
  const trr = borderTopRightRadius || borderRadius;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(trr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(trr, styles, mediaQueries, "borderTopRightRadius");
  } else {
    styles.borderTopRightRadius = trr;
  }
  Object.assign(styles, mapPropsToBorderLine(restProps));
};


/***/ }),

/***/ "./src/helpers/properties/dimension.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToDimension": () => (/* binding */ mapPropsToDimension)
/* harmony export */ });
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");

const mapPropsToDimension = ({
  height,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  overflow,
  width
}, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(height)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(height, styles, mediaQueries, "height");
  } else {
    styles.height = height;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(maxHeight)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(maxHeight, styles, mediaQueries, "maxHeight");
  } else {
    styles.maxHeight = maxHeight;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(maxWidth)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(maxWidth, styles, mediaQueries, "maxWidth");
  } else {
    styles.maxWidth = maxWidth;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(width)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(width, styles, mediaQueries, "width");
  } else {
    styles.width = width;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(minHeight)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(minHeight, styles, mediaQueries, "minHeight");
  } else {
    styles.minHeight = minHeight;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(minWidth)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(minWidth, styles, mediaQueries, "minWidth");
  } else {
    styles.minWidth = minWidth;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(overflow)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(overflow, styles, mediaQueries, "overflow");
  } else {
    styles.overflow = overflow;
  }
};


/***/ }),

/***/ "./src/helpers/properties/flexChild.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToFlexChild": () => (/* binding */ mapPropsToFlexChild)
/* harmony export */ });
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");

const mapPropsToFlexChild = ({ alignSelf, flexBasis, flexGrow, flexShrink }, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(alignSelf)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(alignSelf, styles, mediaQueries, "alignSelf");
  } else {
    styles.alignSelf = alignSelf;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(flexBasis)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(flexBasis, styles, mediaQueries, "flexBasis");
  } else {
    styles.flexBasis = flexBasis;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(flexGrow)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(flexGrow, styles, mediaQueries, "flexGrow");
  } else {
    styles.flexGrow = flexGrow;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(flexShrink)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(flexShrink, styles, mediaQueries, "flexShrink");
  } else {
    styles.flexShrink = flexShrink;
  }
};


/***/ }),

/***/ "./src/helpers/properties/flexContainer.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToFlexContainer": () => (/* binding */ mapPropsToFlexContainer)
/* harmony export */ });
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");

const mapPropsToFlexContainer = ({
  alignItems,
  direction = "column",
  flexWrap,
  justifyContent
}, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(alignItems)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(alignItems, styles, mediaQueries, "alignItems");
  } else {
    styles.alignItems = alignItems;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(direction)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(direction, styles, mediaQueries, "flexDirection");
  } else {
    styles.flexDirection = direction;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(flexWrap)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(flexWrap, styles, mediaQueries, "flexWrap");
  } else {
    styles.flexWrap = flexWrap;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(justifyContent)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(justifyContent, styles, mediaQueries, "justifyContent");
  } else {
    styles.justifyContent = justifyContent;
  }
};


/***/ }),

/***/ "./src/helpers/properties/margin.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToMargin": () => (/* binding */ mapPropsToMargin)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const getValue = (value) => {
  if ((0,_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.isSpacingToken)(value)) {
    return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.spacings[value];
  }
  return value;
};
const mapPropsToMargin = ({
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  marginY,
  marginX,
  margin
}, styles, mediaQueries = {}) => {
  const mb = marginBottom || marginY || margin;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(mb)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(mb, styles, mediaQueries, "marginBottom", getValue);
  } else {
    styles.marginBottom = getValue(mb);
  }
  const ml = marginLeft || marginX || margin;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(ml)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(ml, styles, mediaQueries, "marginLeft", getValue);
  } else {
    styles.marginLeft = getValue(ml);
  }
  const mr = marginRight || marginX || margin;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(mr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(mr, styles, mediaQueries, "marginRight", getValue);
  } else {
    styles.marginRight = getValue(mr);
  }
  const mt = marginTop || marginY || margin;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(mt)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(mt, styles, mediaQueries, "marginTop", getValue);
  } else {
    styles.marginTop = getValue(mt);
  }
};


/***/ }),

/***/ "./src/helpers/properties/padding.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getValue": () => (/* binding */ getValue),
/* harmony export */   "mapPropsToPadding": () => (/* binding */ mapPropsToPadding)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const getValue = (value) => {
  if ((0,_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.isSpacingToken)(value)) {
    return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.spacings[value];
  }
  return value;
};
const mapPropsToPadding = ({
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingY,
  paddingX,
  padding
}, styles, mediaQueries = {}) => {
  const pb = paddingBottom || paddingY || padding;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(pb)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(pb, styles, mediaQueries, "paddingBottom", getValue);
  } else {
    styles.paddingBottom = getValue(pb);
  }
  const pl = paddingLeft || paddingX || padding;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(pl)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(pl, styles, mediaQueries, "paddingLeft", getValue);
  } else {
    styles.paddingLeft = getValue(pl);
  }
  const pr = paddingRight || paddingX || padding;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(pr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(pr, styles, mediaQueries, "paddingRight", getValue);
  } else {
    styles.paddingRight = getValue(pr);
  }
  const pt = paddingTop || paddingY || padding;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(pt)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(pt, styles, mediaQueries, "paddingTop", getValue);
  } else {
    styles.paddingTop = getValue(pt);
  }
};


/***/ }),

/***/ "./src/helpers/properties/position.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToPosition": () => (/* binding */ mapPropsToPosition)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const mapPropsToPosition = ({ absoluteFill, position, top, left, bottom, right }, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(position)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(position, styles, mediaQueries, "position");
  } else {
    styles.position = position;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(top)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(top, styles, mediaQueries, "top", getValue);
  } else {
    styles.top = getValue(top);
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(left)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(left, styles, mediaQueries, "left", getValue);
  } else {
    styles.left = getValue(left);
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(bottom)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(bottom, styles, mediaQueries, "bottom", getValue);
  } else {
    styles.bottom = getValue(bottom);
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(right)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(right, styles, mediaQueries, "right", getValue);
  } else {
    styles.right = getValue(right);
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(absoluteFill)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(
      absoluteFill,
      styles,
      mediaQueries,
      "position",
      () => "absolute"
    );
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(absoluteFill, styles, mediaQueries, "left", () => 0);
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(absoluteFill, styles, mediaQueries, "right", () => 0);
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(absoluteFill, styles, mediaQueries, "bottom", () => 0);
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(absoluteFill, styles, mediaQueries, "top", () => 0);
  } else if (absoluteFill) {
    styles.position = "absolute";
    styles.bottom = 0;
    styles.left = 0;
    styles.right = 0;
    styles.top = 0;
  }
};
const getValue = (value) => {
  if ((0,_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.isSpacingToken)(value)) {
    return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.spacings[value];
  }
  return value;
};


/***/ }),

/***/ "./src/helpers/properties/responsive/responsive.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NEXT_SMALLEST_BREAKPOINT_MAP": () => (/* binding */ NEXT_SMALLEST_BREAKPOINT_MAP),
/* harmony export */   "handleResponsive": () => (/* binding */ handleResponsive),
/* harmony export */   "isBreakpointValue": () => (/* binding */ isBreakpointValue),
/* harmony export */   "resolveBreakpointValue": () => (/* binding */ resolveBreakpointValue)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);

const media = {
  small: `@media (min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints.small}px)`,
  medium: `@media (min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints.medium}px)`,
  large: `@media (min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints.large}px)`,
  xlarge: `@media (min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints.xlarge}px)`
};
const handleResponsive = (prop, styles, mediaQueries, key, getValue) => {
  const setValueForMediaQuery = (breakpointKey) => {
    const breakpointValue = prop[breakpointKey];
    if (breakpointValue === void 0) {
      return;
    }
    const value = typeof getValue === "function" ? getValue(breakpointValue) : breakpointValue;
    const mediaObject = mediaQueries[media[breakpointKey]];
    if (mediaObject)
      mediaObject[key] = value;
    else
      mediaQueries[media[breakpointKey]] = { [key]: value };
  };
  if (prop.xsmall !== void 0) {
    styles[key] = typeof getValue === "function" ? getValue(prop.xsmall) : prop.xsmall;
  }
  setValueForMediaQuery("small");
  setValueForMediaQuery("medium");
  setValueForMediaQuery("large");
  setValueForMediaQuery("xlarge");
};
const isBreakpointValue = (prop) => {
  return typeof prop === "object" && prop != null && ("xsmall" in prop || "small" in prop || "medium" in prop || "large" in prop || "xlarge" in prop);
};
const breakpointKeys = Object.keys(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints);
const NEXT_SMALLEST_BREAKPOINT_MAP = breakpointKeys.reduce(
  (acc, bp, currentIndex) => {
    if (currentIndex === 0) {
      acc[bp] = void 0;
    } else {
      acc[bp] = breakpointKeys[currentIndex - 1];
    }
    return acc;
  },
  {}
);
const resolveBreakpointValue = (prop, breakpointKey) => {
  if (prop[breakpointKey] !== void 0) {
    return prop[breakpointKey];
  } else {
    const nextSmallestBreakpoint = NEXT_SMALLEST_BREAKPOINT_MAP[breakpointKey];
    if (!nextSmallestBreakpoint)
      return;
    return resolveBreakpointValue(prop, nextSmallestBreakpoint);
  }
};


/***/ }),

/***/ "./src/helpers/properties/shadow/mapPropsToShadow.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToShadow": () => (/* binding */ mapPropsToShadow)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/color/index.ts");


const OUTLINE_SHADOW = `0 0 0 ${2}px ${(0,_color__WEBPACK_IMPORTED_MODULE_0__.resolveColor)("blue60")}`;
const mapPropsToShadow = ({ shadow, withOutline }, styles) => {
  const outlineShadow = withOutline ? OUTLINE_SHADOW : void 0;
  const normalShadow = shadow ? _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.shadows[shadow] : void 0;
  styles["&:focus"] = {
    outline: "2px solid transparent"
  };
  styles.boxShadow = [outlineShadow, normalShadow].filter(Boolean).join(",");
};


/***/ }),

/***/ "./src/helpers/properties/stacking.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StackingContextProvider": () => (/* binding */ StackingContextProvider),
/* harmony export */   "createZIndex": () => (/* binding */ createZIndex),
/* harmony export */   "mapPropsToStacking": () => (/* binding */ mapPropsToStacking),
/* harmony export */   "useStackingContext": () => (/* binding */ useStackingContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);


const mapPropsToStacking = ({ stackLayer, stackPriority }, styles) => {
  if (stackLayer || stackPriority) {
    styles.zIndex = createZIndex({ stackLayer, stackPriority });
  }
};
const StackingContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const StackingContextProvider = StackingContext.Provider;
const createZIndex = ({
  stackLayer = "default",
  stackPriority = 0
}) => {
  return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.stackings[stackLayer] + stackPriority;
};
const useStackingContext = ({
  stackLayer,
  stackPriority
}) => {
  const stackContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StackingContext);
  if (stackContext) {
    return {
      stackLayer: stackContext.stackLayer,
      stackPriority: stackContext.stackPriority
    };
  }
  return {
    stackLayer,
    stackPriority
  };
};


/***/ }),

/***/ "./src/helpers/properties/testing.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToTestingProps": () => (/* binding */ mapPropsToTestingProps)
/* harmony export */ });
const mapPropsToTestingProps = ({ testId }, boxProps) => {
  if (testId === void 0)
    return;
  boxProps["data-testid"] = testId;
};


/***/ }),

/***/ "./src/helpers/properties/transforms.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToTransforms": () => (/* binding */ mapPropsToTransforms)
/* harmony export */ });
const mapPropsToTransforms = ({ transform }, styles) => {
  if (transform) {
    styles.transform = transform.map((t) => {
      const [keyValuePair] = Object.entries(t);
      const transformFunction = keyValuePair[0];
      let value = keyValuePair[1];
      if (transformFunction === "translateX" || transformFunction === "translateY") {
        value = `${value}px`;
      }
      return `${transformFunction}(${value})`;
    }).join(" ");
  }
};


/***/ }),

/***/ "./src/helpers/properties/visiblyHidden/visiblyHidden.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToVisiblyHidden": () => (/* binding */ mapPropsToVisiblyHidden)
/* harmony export */ });
const mapPropsToVisiblyHidden = ({ visiblyHidden }, styles) => {
  if (visiblyHidden) {
    styles.clip = "rect(1, 1, 1, 1)";
    styles.clipPath = "inset(50%)";
    styles.height = 1;
    styles.margin = -1;
    styles.overflow = "hidden";
    styles.padding = 0;
    styles.position = "absolute";
    styles.width = 1;
  }
};


/***/ }),

/***/ "./src/helpers/properties/web.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToWeb": () => (/* binding */ mapPropsToWeb)
/* harmony export */ });
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");

const mapPropsToWeb = ({ display }, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(display)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(display, styles, mediaQueries, "display");
  } else {
    styles.display = display;
  }
};


/***/ }),

/***/ "./src/helpers/useAccessibilityListener/constants/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_REDUCED_MOTION": () => (/* binding */ DEFAULT_REDUCED_MOTION),
/* harmony export */   "DEFAULT_RING_VISIBILITY": () => (/* binding */ DEFAULT_RING_VISIBILITY)
/* harmony export */ });
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/platform/index.ts");

const DEFAULT_REDUCED_MOTION = _platform__WEBPACK_IMPORTED_MODULE_0__.isTestingEnvironment;
const DEFAULT_RING_VISIBILITY = false;


/***/ }),

/***/ "./src/helpers/useAccessibilityListener/helpers/useFocusRing/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useFocusRing": () => (/* binding */ useFocusRing)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useAccessibilityListener/constants/index.ts");


const useFocusRing = () => {
  const isVisible = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(_constants__WEBPACK_IMPORTED_MODULE_1__.DEFAULT_RING_VISIBILITY);
  const getFocusRingVisibility = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => isVisible.current, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const hide = () => {
      isVisible.current = false;
    };
    const display = () => {
      isVisible.current = true;
    };
    window.addEventListener("mousemove", hide);
    window.addEventListener("mousedown", hide);
    window.addEventListener("keydown", display);
    return () => {
      window.removeEventListener("mousemove", hide);
      window.removeEventListener("mousedown", hide);
      window.removeEventListener("keydown", display);
    };
  }, []);
  return getFocusRingVisibility;
};


/***/ }),

/***/ "./src/helpers/useAccessibilityListener/helpers/useReducedMotion/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useReducedMotion": () => (/* binding */ useReducedMotion)
/* harmony export */ });
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/platform/Platform.ts");
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/platform/index.ts");
/* harmony import */ var _useMediaQueryListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/useMediaQueryListener/useMediaQueryListener.ts");


const useReducedMotion = () => {
  return (0,_useMediaQueryListener__WEBPACK_IMPORTED_MODULE_0__.useMediaQueryListener)(
    "(prefers-reduced-motion: reduce)",
    // @note: animations are not reduced on server like envs (except testing env)
    // to allow CSS extraction on SSR (Server Side Rendering) / SSG (Static Site Generation)
    _platform__WEBPACK_IMPORTED_MODULE_1__.Platform.isServer ? false : _platform__WEBPACK_IMPORTED_MODULE_2__.isTestingEnvironment
  );
};


/***/ }),

/***/ "./src/helpers/useAccessibilityListener/useAccessibilityListener.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useAccessibilityListener": () => (/* binding */ useAccessibilityListener)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_useReducedMotion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useAccessibilityListener/helpers/useReducedMotion/index.ts");
/* harmony import */ var _helpers_useFocusRing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/useAccessibilityListener/helpers/useFocusRing/index.ts");



const useAccessibilityListener = () => {
  const hasReducedMotion = (0,_helpers_useReducedMotion__WEBPACK_IMPORTED_MODULE_1__.useReducedMotion)();
  const getFocusRingVisibility = (0,_helpers_useFocusRing__WEBPACK_IMPORTED_MODULE_2__.useFocusRing)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({ hasReducedMotion, getFocusRingVisibility }),
    [getFocusRingVisibility, hasReducedMotion]
  );
};


/***/ }),

/***/ "./src/helpers/useBreakpointAttributes/useBreakpointAttributes.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useBreakpointAttributes": () => (/* binding */ useBreakpointAttributes)
/* harmony export */ });
/* harmony import */ var _useBreakpointListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/useBreakpointListener/useBreakpointListener.tsx");
/* harmony import */ var _properties_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const useBreakpointAttributes = (props) => {
  const breakpoint = (0,_useBreakpointListener__WEBPACK_IMPORTED_MODULE_0__.useBreakpointListener)();
  const registry = {};
  for (const key in props) {
    let value = props[key];
    if (value === void 0) {
      continue;
    }
    if ((0,_properties_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(value)) {
      value = (0,_properties_responsive__WEBPACK_IMPORTED_MODULE_1__.resolveBreakpointValue)(
        value,
        breakpoint
      );
    }
    Object.assign(registry, {
      [key]: value
    });
  }
  return registry;
};


/***/ }),

/***/ "./src/helpers/useBreakpointListener/useBreakpointListener.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useBreakpointListener": () => (/* binding */ useBreakpointListener)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _useMediaQueryListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useMediaQueryListener/useMediaQueryListener.ts");
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/platform/Platform.ts");
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/platform/index.ts");




const useBreakpointListener = () => {
  const isSmallBreakpoint = (0,_useMediaQueryListener__WEBPACK_IMPORTED_MODULE_1__.useMediaQueryListener)(getBreakpointQuery("small"));
  const isMediumBreakpoint = (0,_useMediaQueryListener__WEBPACK_IMPORTED_MODULE_1__.useMediaQueryListener)(getBreakpointQuery("medium"));
  const isLargeBreakpoint = (0,_useMediaQueryListener__WEBPACK_IMPORTED_MODULE_1__.useMediaQueryListener)(getBreakpointQuery("large"));
  const isXlargeBreakpoint = (0,_useMediaQueryListener__WEBPACK_IMPORTED_MODULE_1__.useMediaQueryListener)(
    getBreakpointQuery("xlarge"),
    _platform__WEBPACK_IMPORTED_MODULE_2__.Platform.isServer || _platform__WEBPACK_IMPORTED_MODULE_3__.isTestingEnvironment
  );
  const breakpoint = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    switch (true) {
      case isXlargeBreakpoint:
        return "xlarge";
      case isLargeBreakpoint:
        return "large";
      case isMediumBreakpoint:
        return "medium";
      case isSmallBreakpoint:
        return "small";
      default:
        return "xsmall";
    }
  }, [
    isXlargeBreakpoint,
    isLargeBreakpoint,
    isMediumBreakpoint,
    isSmallBreakpoint
  ]);
  return breakpoint;
};
const getBreakpointQuery = (token) => `(min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4__.breakpoints[token]}px)`;


/***/ }),

/***/ "./src/helpers/useBreakpointValue/useBreakpointValue.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useBreakpointValue": () => (/* binding */ useBreakpointValue)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _useBreakpointListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useBreakpointListener/useBreakpointListener.tsx");
/* harmony import */ var _properties_responsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");



const useBreakpointValue = (value) => {
  const breakpoint = (0,_useBreakpointListener__WEBPACK_IMPORTED_MODULE_1__.useBreakpointListener)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => (0,_properties_responsive__WEBPACK_IMPORTED_MODULE_2__.resolveBreakpointValue)(value, breakpoint) ?? value["xsmall"],
    [value, breakpoint]
  );
};


/***/ }),

/***/ "./src/helpers/useElementResizeListener/useElementResizeListener.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useElementResizeListener": () => (/* binding */ useElementResizeListener)
/* harmony export */ });
/* harmony import */ var _useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/useIsomorphicLayoutEffect/index.ts");

const useElementResizeListener = (targetRef, callback) => {
  (0,_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
    const element = targetRef.current;
    if (!element) {
      return;
    }
    const resizeObserver = getResizeObserver(callback);
    resizeObserver.subscribe(element);
    return () => {
      resizeObserver.unsubscribe(element);
    };
  }, [callback, targetRef]);
};
const getResizeObserver = (callback) => {
  const hasNativeResizeObserver = typeof window.ResizeObserver !== "undefined";
  let intervalId;
  let resizeObserver;
  return {
    subscribe(element) {
      if (hasNativeResizeObserver) {
        resizeObserver = new ResizeObserver(callback);
        resizeObserver.observe(element);
      } else {
        intervalId = setInterval(callback, 1e3);
      }
    },
    unsubscribe(element) {
      if (hasNativeResizeObserver) {
        if (resizeObserver) {
          resizeObserver.unobserve(element);
        }
      } else {
        clearTimeout(intervalId);
      }
    }
  };
};


/***/ }),

/***/ "./src/helpers/useIsomorphicLayoutEffect/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useIsomorphicLayoutEffect": () => (/* binding */ useIsomorphicLayoutEffect)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/platform/Platform.ts");
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/platform/index.ts");


const useIsomorphicLayoutEffect = _platform__WEBPACK_IMPORTED_MODULE_1__.Platform.isServer || _platform__WEBPACK_IMPORTED_MODULE_2__.isTestingEnvironment ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;


/***/ }),

/***/ "./src/helpers/useMediaQueryListener/useMediaQueryListener.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useMediaQueryListener": () => (/* binding */ useMediaQueryListener)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/platform/Platform.ts");
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/platform/index.ts");
/* harmony import */ var _useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useIsomorphicLayoutEffect/index.ts");



const useMediaQueryListener = (query, fallbackValue = false) => {
  const mediaQuery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => createMediaQuery(query), [query]);
  const [isMatched, setIsMatched] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    mediaQuery ? getIsMatchedMedia(mediaQuery) : fallbackValue
  );
  (0,_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
    if (!mediaQuery) {
      return;
    }
    const handleMatchMedia = () => {
      setIsMatched(getIsMatchedMedia(mediaQuery));
    };
    mediaQuery.addListener(handleMatchMedia);
    return () => {
      mediaQuery.removeListener(handleMatchMedia);
    };
  });
  return isMatched;
};
const createMediaQuery = (query) => {
  const isRealBrowserEnvironment = !_platform__WEBPACK_IMPORTED_MODULE_2__.Platform.isServer && !_platform__WEBPACK_IMPORTED_MODULE_3__.isTestingEnvironment;
  return isRealBrowserEnvironment ? window.matchMedia(query) : null;
};
const getIsMatchedMedia = (mediaQuery) => {
  return mediaQuery.matches;
};


/***/ }),

/***/ "./src/helpers/useTheme/useTheme.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useTheme": () => (/* binding */ useTheme)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);


const DEFAULT_THEME = {
  spacings: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.spacings,
  typographies: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.typographies
};
const useTheme = () => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(DEFAULT_THEME);
  return theme.current;
};


/***/ }),

/***/ "./src/helpers/useToken/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useToken": () => (/* binding */ useToken)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/useTheme/useTheme.tsx");


const useToken = () => {
  const { spacings, typographies } = (0,_useTheme__WEBPACK_IMPORTED_MODULE_0__.useTheme)();
  return {
    breakpoints: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.breakpoints,
    colors: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.colors,
    radii: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.radii,
    shadows: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.shadows,
    spacings,
    stackings: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.stackings,
    typographies
  };
};


/***/ }),

/***/ "./src/helpers/useWarning/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useWarning": () => (/* binding */ useWarning),
/* harmony export */   "warn": () => (/* binding */ warn)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/platform/index.ts");


const warn = (data) => {
  if (!_platform__WEBPACK_IMPORTED_MODULE_1__.isDevEnvironment || _platform__WEBPACK_IMPORTED_MODULE_1__.isTestingEnvironment) {
    return;
  }
};
const useWarning = (data, isDisplayable = true) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (isDisplayable) {
      warn(data);
    }
  }, [data, isDisplayable]);
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/breakpoints.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.breakpoints = void 0;
// Breakpoint naming follows size property convention (eg. Avatar size...)
exports.breakpoints = {
    xsmall: 0,
    small: 576,
    medium: 768,
    large: 992,
    xlarge: 1280,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/colors.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.colors = void 0;
exports.colors = {
    black: '#000000',
    white: '#FFFFFF',
    // Blue
    blue400: '#011F40',
    blue300: '#094285',
    blue200: '#0C5AB3',
    blue100: '#0F6FDE',
    blue80: '#3587E6',
    blue60: '#89BEFA',
    blue40: '#B4D5FA',
    blue20: '#EBF4FF',
    // Azure
    azure400: '#002C33',
    azure300: '#007180',
    azure200: '#009BB0',
    azure100: '#00BFD9',
    azure80: '#2BC9DF',
    azure60: '#7EE0ED',
    azure40: '#B5ECF5',
    azure20: '#EBFCFF',
    // Purple
    purple400: '#1C0F46',
    purple300: '#371E8A',
    purple200: '#4926BD',
    purple100: '#5F34ED',
    purple80: '#7854F0',
    purple60: '#A890F5',
    purple40: '#CFC2F9',
    purple20: '#EFEBFF',
    // Green
    green400: '#002E14',
    green300: '#007332',
    green200: '#009C44',
    green100: '#00C455',
    green80: '#29CF71',
    green60: '#7BE0A7',
    green40: '#B6F0CF',
    green20: '#EBFFF3',
    // Yellow
    yellow400: '#382400',
    yellow300: '#996300',
    yellow200: '#CC8400',
    yellow100: '#FFA600',
    yellow80: '#FFB52B',
    yellow60: '#FFD17A',
    yellow40: '#FFEED1',
    yellow20: '#FFF6E6',
    // Red
    red400: '#470F0B',
    red300: '#901F16',
    red200: '#CD2C20',
    red100: '#F13426',
    red80: '#FF756B',
    red60: '#FF9D96',
    red40: '#FFC6C2',
    red20: '#FFEDEB',
    // Navy
    navy200: '#042040',
    navy100: '#132D4A',
    navy90: '#223954',
    navy80: '#364A61',
    navy70: '#485B70',
    navy60: '#55687D',
    navy50: '#65778C',
    navy40: '#768699',
    navy30: '#8594A6',
    navy20: '#96A3B3',
    // Silver
    silver300: '#ABBBCC',
    silver200: '#BAC8D6',
    silver100: '#D1DAE6',
    silver80: '#DFE6ED',
    silver60: '#EBF0F5',
    silver40: '#F0F3F7',
    silver20: '#F7F9FC',
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/index.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.theme = exports.breakpoints = exports.typographies = exports.stackings = exports.isSpacingToken = exports.spacings = exports.shadows = exports.radii = exports.colors = void 0;
var colors_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/colors.js");
Object.defineProperty(exports, "colors", ({ enumerable: true, get: function () { return colors_1.colors; } }));
var radii_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/radii.js");
Object.defineProperty(exports, "radii", ({ enumerable: true, get: function () { return radii_1.radii; } }));
var shadows_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/shadows.js");
Object.defineProperty(exports, "shadows", ({ enumerable: true, get: function () { return shadows_1.shadows; } }));
var spacings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/spacings.js");
Object.defineProperty(exports, "spacings", ({ enumerable: true, get: function () { return spacings_1.spacings; } }));
Object.defineProperty(exports, "isSpacingToken", ({ enumerable: true, get: function () { return spacings_1.isSpacingToken; } }));
var stackings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/stackings.js");
Object.defineProperty(exports, "stackings", ({ enumerable: true, get: function () { return stackings_1.stackings; } }));
var typographies_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/typographies.js");
Object.defineProperty(exports, "typographies", ({ enumerable: true, get: function () { return typographies_1.typographies; } }));
var breakpoints_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/breakpoints.js");
Object.defineProperty(exports, "breakpoints", ({ enumerable: true, get: function () { return breakpoints_1.breakpoints; } }));
var theme_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/theme.js");
Object.defineProperty(exports, "theme", ({ enumerable: true, get: function () { return theme_1.theme; } }));
__exportStar(__webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/index.js"), exports);


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/radii.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.radii = void 0;
exports.radii = {
    medium: 6,
    large: 8,
    xlarge: 16,
    rounded: 100,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/shadows.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shadows = void 0;
const getShadowValue = ({ x, y, blur, spread, color, }) => {
    return [`${x}px`, `${y}px`, `${blur}px`, `${spread}px`, color].join(' ');
};
const shadowBlack14 = 'rgba(0, 0, 0, 0.14)';
exports.shadows = {
    'shadow-100': getShadowValue({
        x: 0,
        y: 1,
        blur: 2,
        spread: 0,
        color: 'rgba(0, 0, 0, 0.05)',
    }),
    'shadow-150': getShadowValue({
        x: 0,
        y: 3,
        blur: 6,
        spread: -4,
        color: 'rgba(0, 0, 0, 0.22)',
    }),
    'shadow-200': getShadowValue({
        x: 0,
        y: 7,
        blur: 14,
        spread: -4,
        color: shadowBlack14,
    }),
    'shadow-300': getShadowValue({
        x: 0,
        y: 12,
        blur: 24,
        spread: -6,
        color: shadowBlack14,
    }),
    'shadow-400': getShadowValue({
        x: 0,
        y: 22,
        blur: 30,
        spread: -8,
        color: shadowBlack14,
    }),
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/spacings.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isSpacingToken = exports.spacings = void 0;
exports.spacings = {
    'spacing-0': 0,
    'spacing-40': 4,
    'spacing-60': 8,
    'spacing-80': 12,
    'spacing-100': 16,
    'spacing-200': 24,
    'spacing-300': 32,
    'spacing-400': 40,
    'spacing-500': 48,
    'spacing-600': 64,
};
const isSpacingToken = (value) => typeof value === 'string' ? value in exports.spacings : false;
exports.isSpacingToken = isSpacingToken;


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/stackings.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stackings = void 0;
exports.stackings = {
    default: 0,
    layout: 20,
    popover: 50,
    overlay: 100,
    notification: 150,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/theme.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.theme = void 0;
const colors_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/colors.js");
const radii_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/radii.js");
const shadows_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/shadows.js");
const spacings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/spacings.js");
const stackings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/stackings.js");
const typographies_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/typographies.js");
const breakpoints_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/breakpoints.js");
exports.theme = {
    colors: colors_1.colors,
    radii: radii_1.radii,
    shadows: shadows_1.shadows,
    spacings: spacings_1.spacings,
    stackings: stackings_1.stackings,
    typographies: typographies_1.typographies,
    breakpoints: breakpoints_1.breakpoints,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/typographies.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.typographies = void 0;
exports.typographies = {
    'text-700': {
        fontSize: 35,
        fontVariation: 'bold',
    },
    'text-600': {
        fontSize: 28,
        fontVariation: 'bold',
    },
    'text-500': {
        fontSize: 22,
        fontVariation: 'bold',
    },
    'text-400': {
        fontSize: 20,
        fontVariation: 'bold',
    },
    'text-300': {
        fontSize: 16,
        fontVariation: 'bold',
    },
    'text-200': {
        fontSize: 16,
        fontVariation: 'normal',
    },
    'text-100-medium': {
        fontSize: 14,
        fontVariation: 'bold',
    },
    'text-100': {
        fontSize: 14,
        fontVariation: 'normal',
    },
    'text-80': {
        fontSize: 13,
        fontVariation: 'normal',
    },
    'text-60-caps': {
        fontSize: 11,
        textTransform: 'uppercase',
        fontWeight: 600,
        fontVariation: 'normal',
    },
    'text-60': {
        fontSize: 11,
        fontVariation: 'normal',
    },
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/v2/breakpoints.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.breakpoints = void 0;
// Breakpoint naming follows size property convention (eg. Avatar size...)
exports.breakpoints = {
    xs: 0,
    sm: 490,
    md: 768,
    lg: 1040,
    xl: 1440,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/v2/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V2Tokens = void 0;
const breakpoints_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/breakpoints.js");
const radii_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/radii.js");
const theme_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/theme.js");
exports.V2Tokens = {
    radii: radii_1.radii,
    breakpoints: breakpoints_1.breakpoints,
    theme: theme_1.theme,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/v2/radii.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.radii = void 0;
exports.radii = {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    '2xl': 24,
    '3xl': 32,
    /*
       This avoid unwanted elliptical shapes https://github.com/tailwindlabs/tailwindcss/issues/1949#issuecomment-650328183
       and ensure that the shape rendered will always be a circle
       */
    rounded: 9999,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/v2/theme.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.theme = void 0;
// V1 Tokens
const colors_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/colors.js");
const shadows_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/shadows.js");
const spacings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/spacings.js");
const stackings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/stackings.js");
const typographies_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/typographies.js");
// V2 Tokens
const breakpoints_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/breakpoints.js");
const radii_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/radii.js");
exports.theme = {
    colors: colors_1.colors,
    radii: radii_1.radii,
    shadows: shadows_1.shadows,
    spacings: spacings_1.spacings,
    stackings: stackings_1.stackings,
    typographies: typographies_1.typographies,
    breakpoints: breakpoints_1.breakpoints,
};


/***/ }),

/***/ "@emotion/css":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__emotion_css__;

/***/ }),

/***/ "@emotion/react":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__emotion_react__;

/***/ }),

/***/ "react":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-dom":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;

/***/ }),

/***/ "react/jsx-runtime":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tooltip": () => (/* reexport safe */ _Tooltip__WEBPACK_IMPORTED_MODULE_0__.Tooltip)
/* harmony export */ });
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/Tooltip/Tooltip.tsx");


})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map